import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import redMapPointer from '../../images/address.png';
import { Row, Col, Modal } from 'reactstrap';
import { IconContext } from 'react-icons';
import { GrAdd, GrClose } from 'react-icons/gr';
import { FaCheckCircle } from 'react-icons/fa';
import ModalAddAddress from './ModalAddAddressV3';
import {
  setDefaultAddress,
  deleteShippingAddress,
} from '../../actions/postalCodeAction';
import { connect } from 'react-redux';
import {
  CountriesInterface,
  ProvinceInterface,
  ShippingHistoryInterface,
} from '../../interface/reducers/postalCode';

interface ModalAddressBookV3Interface {
  dataAddress: ShippingHistoryInterface[];
  isOpen: boolean;
  onToggle: any;
  provinces: ProvinceInterface[];
  countries: CountriesInterface[];
  id: number | null;
  changeId: any;
  defaultId: any;
  submitShipping: any;
  cities: any[];
  changeAddressDefault: any;
  getHistoryShipping: any;
  deleteShippingAddress: any;
  isModalOffer: boolean;
  isAddressButtonDisable: boolean;
  modalTitle?: string;
  type?: string;
  setDefaultTempAddress?: any;
  defaultAddressTemp?: any;
}

/**
 * Modal for Address Book Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com) updated from ModalAddressBook V2 by Juan
 * ===============================================
 * @param {ModalAddressBookV3Interface} props for this component.
 * @return {JSX.Element}
 */
function ModalAddressBookV3({
  dataAddress,
  isOpen,
  onToggle,
  provinces,
  countries,
  id,
  changeId,
  defaultId,
  submitShipping,
  cities,
  changeAddressDefault,
  getHistoryShipping,
  deleteShippingAddress,
  isModalOffer,
  isAddressButtonDisable,
  modalTitle,
  type,
  setDefaultTempAddress,
  defaultAddressTemp,
}: ModalAddressBookV3Interface): JSX.Element {
  const [modalForm, setModalForm] = useState<boolean>(false);
  const [titleHeader, setTitleHeader] = useState<string>('');
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [editId, setEditId] = useState<number | undefined>(0);
  const [deleteId, setDeleteId] = useState<number>(0);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [defaultAddressId, setDefaultAddressId] = useState(null);
  const [filteredAddress, setFilteredAddress] = useState<
    ShippingHistoryInterface[]
  >([]);

  // Modal edit
  const toggleModalForm = (title: string, id: number | null) => {
    if (title === 'Edit Address') {
      setIsEdit(true);
      setTitleHeader(title);
      setModalForm(!modalForm);
      setEditId(id);
    } else {
      if (modalForm) {
        getHistoryShipping();
      }
      setIsEdit(false);
      setTitleHeader(title);
      setModalForm(!modalForm);
    }
  };

  const changeDefaultAddress = (id: number) => {
    setDefaultAddressId(id);
    setDefaultTempAddress(id);
    changeAddressDefault(id)
      // .then(() => getHistoryShipping())
      .then(() => null)
      .catch(() => null);
  };

  useEffect(() => {
    if (defaultAddressTemp) {
      setDefaultAddressId(defaultAddressTemp);

      const addressWithoutDefaultAddress = dataAddress?.filter(
        (adrs) => adrs.id !== defaultAddressTemp,
      );
      const onlyDefaultAddressData = dataAddress?.filter(
        (adrs) => adrs.id === defaultAddressTemp,
      );
      setFilteredAddress([
        ...onlyDefaultAddressData,
        ...addressWithoutDefaultAddress,
      ]);
    } else {
      getHistoryShipping();
    }
  }, []);

  useEffect(() => {
    dataAddress.forEach((address, index) => {
      address.is_default && setDefaultAddressId(address.id);
    });
    setFilteredAddress(dataAddress);
  }, [dataAddress]);

  const openDeleteConfirmation = (id: number) => {
    setDeleteId(id);
    setOpenConfirmationModal(true);
  };

  const deleteAddress = () => {
    deleteShippingAddress(deleteId)
      .then(() => {
        getHistoryShipping();
      })
      .catch(() => null);
  };

  if (modalForm) {
    return (
      <ModalAddAddress
        dataAddress={dataAddress}
        isOpen={modalForm}
        onToggle={toggleModalForm}
        title={titleHeader}
        countries={countries}
        isEdit={isEdit}
        editId={editId}
        toggleAdd={onToggle}
      />
    );
  } else if (type === 'set-default') {
    return (
      <Modal
        isOpen={isOpen}
        toggle={onToggle}
        modalClassName={'container-address-v3'}
        contentClassName={'main-content'}
      >
        <div className="address-header">
          <div className="text-title">
            <p>{modalTitle ? modalTitle : titleHeader}</p>
          </div>
          {dataAddress.length > 0 && (
            <div
              onClick={() => toggleModalForm('Add New Address', null)}
              className="add-address"
            >
              <IconContext.Provider value={{ color: '#242424', size: '16px' }}>
                <div>
                  <GrAdd />
                </div>
              </IconContext.Provider>
              <span>New Address</span>
            </div>
          )}
        </div>
        <div className="address-content">
          {dataAddress.length > 0 &&
            dataAddress.map(
              (
                item: ShippingHistoryInterface,
                index: React.Key | null | undefined,
              ) => {
                const selectedCountry = countries
                  ? countries.find(
                      (c: { code3: any }) => c.code3 === item.country,
                    )
                  : null;

                return (
                  <Row key={index}>
                    <Col sm={6} md={8} lg={10}>
                      <p>
                        {item.alias} - {item.full_name}
                      </p>
                      <p>{item.phone_number}</p>
                      <p>{item.street_address}</p>
                      <p>{item.note}</p>
                      <p className={selectedCountry ? '' : 'mb12'}>
                        {item.city}, {item.province}, {item.postal_code}
                      </p>
                      {selectedCountry ? <p>{selectedCountry.name}</p> : null}
                      <div className="address-btn">
                        {item.is_default && (
                          <div
                            style={{
                              backgroundColor: item.is_default
                                ? '#159953'
                                : '#fff',
                              color: item.is_default ? '#fff' : '#159953',
                              padding: item.is_default ? '4px 16px' : '0px',
                            }}
                            className="address-default"
                          >
                            {item.is_default
                              ? 'Default Address'
                              : 'Set Default Address'}
                          </div>
                        )}
                        <div
                          onClick={() =>
                            toggleModalForm('Edit Address', item.id)
                          }
                          className="address-edit"
                        >
                          Edit
                        </div>
                        {!item.is_default && (
                          <div
                            onClick={() => openDeleteConfirmation(item.id)}
                            className="address-delete"
                          >
                            Delete
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col sm={6} md={4} lg={2}>
                      {id === item.id ? (
                        <IconContext.Provider
                          value={{ color: '#159953', size: '20px' }}
                        >
                          <div>
                            <FaCheckCircle />
                          </div>
                        </IconContext.Provider>
                      ) : (
                        <input
                          style={{ cursor: 'pointer' }}
                          checked={id === item.id}
                          type="radio"
                          onClick={() => changeId(item.id)}
                        />
                      )}
                    </Col>
                  </Row>
                );
              },
            )}
          {dataAddress.length <= 0 && (
            <div className="address-no-data">
              <KickImage
                // style={{
                //   width: '180px',
                //   height: 'auto',
                //   // margin: '0px 0px 15px 0px',
                //   display: 'block',
                //   margin: '20px auto 20px auto',
                // }}
                src={redMapPointer}
                alt="address point"
              />
              <h4
              // style={{
              //   fontSize: '12px',
              //   textAlign: 'center',
              //   fontFamily: 'Nunito Bold',
              // }}
              >
                You haven't add any address yet
              </h4>
              <h4
              // style={{
              //   fontSize: '12px',
              //   textAlign: 'center',
              //   marginBottom: '15px',
              // }}
              >
                Add your first shipping address by click the button below
              </h4>
              <div
                onClick={() => toggleModalForm('Add New Address', null)}
                className="add-address"
              >
                <span>Add New Address</span>
              </div>
            </div>
          )}
        </div>
        {dataAddress.length > 0 && isAddressButtonDisable ? (
          <div className="address-footer">
            <Row className="row-bottom">
              <Col onClick={submitShipping} className="col-address-book">
                Use This Address
              </Col>
            </Row>
          </div>
        ) : (
          <div className="address-footer">
            <Row className="row-bottom">
              <Col className="col-address-book address-book-disable-button">
                Use This Address
              </Col>
            </Row>
          </div>
        )}
        <div className={'close-button'} onClick={onToggle}>
          <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
            <div>
              <GrClose />
            </div>
          </IconContext.Provider>
        </div>
        <Modal
          isOpen={openConfirmationModal}
          onToggle={() => setOpenConfirmationModal(!openConfirmationModal)}
          id="confirmation-wrapper"
        >
          <div className="confirmation-content-wrapper">
            <p>Delete this address ?</p>
            <div className="button-wrapper">
              <button onClick={() => setOpenConfirmationModal(false)}>
                <p>No</p>
              </button>
              <button
                onClick={() => {
                  setOpenConfirmationModal(false);
                  deleteAddress();
                }}
              >
                <p>Yes</p>
              </button>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  } else {
    return (
      <Modal
        isOpen={isOpen}
        toggle={onToggle}
        modalClassName={'container-address-v3'}
        contentClassName={'main-content'}
      >
        <div className="address-header">
          <div className="text-title">
            <p>{modalTitle ? modalTitle : titleHeader}</p>
          </div>
          {dataAddress.length > 0 && (
            <div
              onClick={() => toggleModalForm('Add New Address', null)}
              className="add-address"
            >
              <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
                <div>
                  <GrAdd />
                </div>
              </IconContext.Provider>
              <span>New Address</span>
            </div>
          )}
        </div>
        <div className="address-content">
          {filteredAddress.length > 0 &&
            filteredAddress.map(
              (
                item: ShippingHistoryInterface,
                index: React.Key | null | undefined,
              ) => {
                const selectedCountry = countries
                  ? countries.find(
                      (c: { code3: any }) => c.code3 === item.country,
                    )
                  : null;

                const _defaultAddressId = defaultAddressTemp
                  ? defaultAddressTemp === item.id
                  : defaultAddressId === item.id;
                return (
                  <Row key={index}>
                    <Col sm={6} md={8} lg={10}>
                      <p>
                        {item.alias} - {item.full_name}
                      </p>
                      <p>{item.phone_number}</p>
                      <p>{item.street_address}</p>
                      <p>{item.note}</p>
                      <p>
                        {item.city}, {item.province}, {item.postal_code}
                      </p>
                      <p>{selectedCountry ? selectedCountry.name : null}</p>
                      <div className="address-btn">
                        <div
                          onClick={() => changeDefaultAddress(item.id)}
                          style={{
                            backgroundColor: _defaultAddressId
                              ? '#159953'
                              : '#fff',
                            color: _defaultAddressId ? '#fff' : '#159953',
                            padding: _defaultAddressId ? '4px 16px' : '0',
                          }}
                          className={`address-default ${
                            _defaultAddressId ? '' : 'unselected-default-addres'
                          }`}
                        >
                          {_defaultAddressId
                            ? 'Default Address'
                            : 'Set Default Address'}
                        </div>
                        <div
                          onClick={() =>
                            toggleModalForm('Edit Address', item.id)
                          }
                          className="address-edit"
                        >
                          Edit
                        </div>
                        {!item.is_default && (
                          <div
                            onClick={() => openDeleteConfirmation(item.id)}
                            className="address-delete"
                          >
                            Delete
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col sm={6} md={4} lg={2} onClick={() => changeId(item.id)}>
                      {id === item.id ? (
                        <IconContext.Provider
                          value={{ color: '#159953', size: '20px' }}
                        >
                          <div onClick={() => changeId(item.id)}>
                            <FaCheckCircle />
                          </div>
                        </IconContext.Provider>
                      ) : (
                        <input
                          style={{ cursor: 'pointer' }}
                          checked={id === item.id}
                          type="radio"
                          onClick={() => changeId(item.id)}
                        />
                      )}
                    </Col>
                  </Row>
                );
              },
            )}
          {dataAddress.length <= 0 && (
            <div className="address-no-data">
              <KickImage
                // style={{
                //   width: '180px',
                //   height: 'auto',
                //   // margin: '0px 0px 15px 0px',
                //   display: 'block',
                //   margin: '20px auto 20px auto',
                // }}
                src={redMapPointer}
                alt="address point"
              />
              <h4
              // style={{
              //   fontSize: '12px',
              //   textAlign: 'center',
              //   fontFamily: 'Nunito Bold',
              // }}
              >
                You haven't add any address yet
              </h4>
              <h4
              // style={{
              //   fontSize: '12px',
              //   textAlign: 'center',
              //   marginBottom: '15px',
              // }}
              >
                Add your first shipping address by click the button below
              </h4>
              <div
                onClick={() => toggleModalForm('Add New Address', null)}
                className="add-address"
              >
                <span>Add New Address</span>
              </div>
            </div>
          )}
        </div>
        {dataAddress.length > 0 && isAddressButtonDisable ? (
          <div className="address-footer">
            <Row className="row-bottom">
              {/* <Col>
              <div onClick={props.onToggle} style={{cursor: 'pointer'}}>
                <span>&lt;&lt; Go Back</span>
              </div>
            </Col> */}
              <Col
                onClick={() => submitShipping()}
                className="col-address-book"
              >
                Use This Address
              </Col>
            </Row>
          </div>
        ) : (
          <div className="address-footer">
            <Row className="row-bottom">
              {/* <Col>
              <div onClick={props.onToggle} style={{cursor: 'pointer'}}>
                <span>&lt;&lt; Go Back</span>
              </div>
            </Col> */}
              <Col className="col-address-book address-book-disable-button">
                Use This Address
              </Col>
            </Row>
          </div>
        )}
        <div className={'close-button'} onClick={onToggle}>
          <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
            <div>
              <GrClose />
            </div>
          </IconContext.Provider>
        </div>
        <Modal
          isOpen={openConfirmationModal}
          onToggle={() => setOpenConfirmationModal(!openConfirmationModal)}
          id="confirmation-wrapper"
        >
          <div className="confirmation-content-wrapper">
            <p>Delete this address ?</p>
            <div className="button-wrapper">
              <button onClick={() => setOpenConfirmationModal(false)}>
                <p>No</p>
              </button>
              <button
                onClick={() => {
                  setOpenConfirmationModal(false);
                  deleteAddress();
                }}
              >
                <p>Yes</p>
              </button>
            </div>
          </div>
        </Modal>
      </Modal>
    );
  }
}

const mapDispatchToProps = (
  dispatch: (arg0: { type: string; payload: Promise<any> }) => any,
) => ({
  changeAddressDefault: (payload: any) => dispatch(setDefaultAddress(payload)),
  deleteShippingAddress: (payload: any) =>
    dispatch(deleteShippingAddress(payload)),
});

export default connect(null, mapDispatchToProps)(ModalAddressBookV3);
